/* DSL Quick-view modal — fetch product html-fragment via /products/{handle}?view=quickview */
(function(){
  function open(handle){
    var modal = document.getElementById("dsl-qv-modal");
    if (!modal) {
      modal = document.createElement("div");
      modal.id = "dsl-qv-modal";
      modal.className = "dsl-qv-modal";
      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-modal", "true");
      modal.innerHTML = "<div class=\"dsl-qv-modal__backdrop\"></div><div class=\"dsl-qv-modal__panel\"><button class=\"dsl-qv-modal__close\" aria-label=\"Sluit\">&times;</button><div data-qv-body>Laden...</div></div>";
      document.body.appendChild(modal);
      modal.querySelector(".dsl-qv-modal__close").addEventListener("click", close);
      modal.querySelector(".dsl-qv-modal__backdrop").addEventListener("click", close);
    }
    modal.classList.add("is-open");
    fetch("/products/" + handle + "?view=quickview").then(function(r){return r.text();}).then(function(html){
      modal.querySelector("[data-qv-body]").innerHTML = html;
    }).catch(function(){
      modal.querySelector("[data-qv-body]").innerHTML = "<p>Kon product niet laden.</p>";
    });
    if (window.DSL_AB) window.DSL_AB.track("quickview_open", {handle: handle});
  }
  function close(){
    var m = document.getElementById("dsl-qv-modal"); if (m) m.classList.remove("is-open");
  }
  document.addEventListener("click", function(e){
    var b = e.target.closest("[data-quick-view]");
    if (!b) return;
    e.preventDefault();
    open(b.dataset.quickView);
  });
  document.addEventListener("keydown", function(e){ if (e.key === "Escape") close(); });
})();